module.exports = __webpack_public_path__ + "static/media/48386135_2308811242527387_5827247580936929280_o-thumb.cfdcf403.jpg";